import { useTranslation } from "react-i18next";
import { PermissionService } from "src/services/permissionService/permissionService";
import { useSelector } from "src/store";

import { selectDevicesByGroupId } from "@devices/store/selectors/devices";
import { Group } from "@devices/types";
import { DangerOutlinedButton } from "@shared/CustomButton";
import { HoverRow } from "@shared/table/HoverRow";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { useCurrentWorkspace } from "@workspaces/api/helpers";

type Props = {
    group: Group;
    isUnassigning: boolean;
    disabled: boolean;
    onUnassign: (groupId: number) => void;
};

export const AssignedGroupRow = ({ group, isUnassigning, disabled, onUnassign }: Props) => {
    const { t } = useTranslation(["pages", "common"]);

    const { groupAbility } = PermissionService();
    const { data: workspace = null } = useCurrentWorkspace();

    const cannotUnassignPolicy = groupAbility(group, workspace).cannot("unassign", "Policy");

    const devices = useSelector((state) => selectDevicesByGroupId(state, group.id));

    return (
        <HoverRow clickable={false}>
            <MinimalTableCell align="left">{group.name}</MinimalTableCell>
            <MinimalTableCell align="left">{devices.length}</MinimalTableCell>
            <MinimalTableCell align="right">
                <DangerOutlinedButton
                    onClick={() => onUnassign(group.id)}
                    loading={isUnassigning}
                    disabled={disabled || cannotUnassignPolicy}
                    tooltipProps={{
                        title: cannotUnassignPolicy
                            ? t("common:tooltip.cannotManagePolicies")
                            : t("pages:policiesPage.tooltip.unassignGroup"),
                    }}
                >
                    <i className="fa-solid fa-fw fa-trash-alt" />
                </DangerOutlinedButton>
            </MinimalTableCell>
        </HoverRow>
    );
};
